export default {
  auth: {
    email: "E-posta",
    password: "Şifre",
    logout: "Çıkış Yap",
    sign_in: "Giriş Yap",
    login_screen: "giriş ekranı",
    back_to_sign_in: "Giriş Ekranına Dön",
    reset_password: "Şifremi Sıfırla",
    reset_password_code: "Sıfırlama Kodu",
    forget_password: "Şifremi Unuttum",
    new_password: "Yeni Şifre ",
    re_new_password: "Yeni Şifre (Tekrar)",
    login_failed: "İdenfit kimliğinizi bulamadı",
    change_password: "Şifremi Değiştir",
    continue: "Devam Et",
    password_change_successfully: "Şifreniz başarıyla değiştirildi",
    showcase: {
      welcome: "Hoşgeldiniz^3000",
      cloud: "Yeni nesil tanımlama ve iş gücü yönetimi bulut platformu^3000",
      identify: "İş gücünüzü kolay ve güvenli bir şekilde tanımlamanızı, izlemenizi ve yönetmenizi sağlar^4000",
      manage: "İstediğiniz zaman, istediğiniz yerde ve istediğiniz şekilde yönetebilirsiniz^4000",
      freedom: "Tüm sisteminizi görmek için özgürsünüz^3000"
    },
    login_with_amazon: "Amazon ile Giriş Yap",
    login_with_google: "Google ile Giriş Yap",
    update_password: "Şifremi Güncelle",
    email_not_found: "Bu email adresi bulunamadı",
    invalid_reset_token: "Geçersiz sıfırlama kodu",
    password_reset_code_sent_to_email: "Şifre sıfırlama kodunuz mail adresinize gönderildi",
    passwordExpireNotificationMessage: "Şifrenizin kullanım süresinin dolmasına {count} gün kaldı | Şifrenizin kullanım süresinin dolmasına {count} gün kaldı | Şifrenizin kullanım süresinin dolmasına {count} gün kaldı"
  }
};
